import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './keycloak';
import { useLanguage } from './LanguageContext.jsx';

export default function Layout({ children }) {
  const { roles, isAdmin, keycloak } = useAuth();
  const { t, changeLanguage, currentLanguage, availableLanguages } = useLanguage();

  // Debug temporal - muestra información de roles en la consola
  React.useEffect(() => {
    if (keycloak.tokenParsed) {
      console.log('🔍 Token Parsed:', keycloak.tokenParsed);
      console.log('🔍 Roles recibidos:', roles);
      console.log('🔍 Realm access:', keycloak.tokenParsed.realm_access);
      console.log('🔍 Resource access:', keycloak.tokenParsed.resource_access);
    }
  }, [roles, keycloak]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-100 text-gray-800">
      <header className="bg-white shadow-md sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2 text-xl font-bold text-blue-700 tracking-wide">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7h18M3 12h18M3 17h18" />
            </svg>
            UOCFiles
          </div>
          <nav className="flex gap-4 items-center text-sm">
            <Link to="/" className="hover:text-blue-500 font-medium">{t('nav.home')}</Link>
            {isAdmin && (
              <Link to="/admin" className="hover:text-blue-500 font-medium flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                {t('nav.admin')}
              </Link>
            )}
            {isAdmin && (
              <Link to="/debug" className="hover:text-blue-500 font-medium flex items-center gap-1 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Debug
              </Link>
            )}

            {/* Selector de idioma */}
            <div className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
              </svg>
              <select
                value={currentLanguage}
                onChange={(e) => changeLanguage(e.target.value)}
                className="text-sm border-none bg-transparent focus:outline-none focus:ring-1 focus:ring-blue-500 rounded px-2 py-1"
              >
                {availableLanguages.map(lang => (
                  <option key={lang.code} value={lang.code}>
                    {lang.name}
                  </option>
                ))}
              </select>
            </div>
            
            <span className="text-gray-600">
              {keycloak.tokenParsed?.preferred_username || t('user.defaultName')}
            </span>
            <button
              onClick={() => keycloak.logout()}
              className="text-red-600 hover:underline"
            >{t('nav.logout')}</button>
          </nav>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6 transition-all duration-300 ease-in-out animate-fade-in">
        {children}
      </main>
    </div>
  );
}
